/**
 * Harvest Mate - OEM Connection API
 *
 * Contact: servicedesk@clevvi.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { DeereDssSubscribeRequest } from '../model/deere-dss-subscribe-request';
// @ts-ignore
import { DeereDssSubscribeResponse } from '../model/deere-dss-subscribe-response';
// @ts-ignore
import { GrantUrl } from '../model/grant-url';
// @ts-ignore
import { OrgGrant } from '../model/org-grant';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class OemDeereGrantsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Register a Deere DSS subscription for fieldOperation events (SRA003-94).
     * Registers a Deere Data Subscription Service (DSS) webhook subscription for &#x60;fieldOperation&#x60; events on a single granted organisation. Persists the resulting Deere subscriptionId on &#x60;oem_webhook_subscriptions&#x60; keyed by &#x60;(provider&#x3D;\&#39;deere\&#39;, connection_id, oem_org_id)&#x60;.  Idempotent: if an active subscription already exists for the (contractor, deere, oem_org_id) tuple, the existing row is returned with &#x60;created: false&#x60; and no Deere call is made.  **License-gated to ACTIVATE**: the Deere &#x60;/platform&#x60; ag-data API is gated on a per-client &#x60;fieldOperation&#x60; entitlement. Unlicensed clients receive a typed 503 &#x60;deere_unlicensed&#x60; (mirrors SRA003-411) instead of a 502, so the FE can render an \&quot;integration pending\&quot; state. 
     * @endpoint post /oem-connection/deere/dss/subscribe
     * @param deereDssSubscribeRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deereDssSubscribe(deereDssSubscribeRequest: DeereDssSubscribeRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<DeereDssSubscribeResponse>;
    public deereDssSubscribe(deereDssSubscribeRequest: DeereDssSubscribeRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<DeereDssSubscribeResponse>>;
    public deereDssSubscribe(deereDssSubscribeRequest: DeereDssSubscribeRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<DeereDssSubscribeResponse>>;
    public deereDssSubscribe(deereDssSubscribeRequest: DeereDssSubscribeRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (deereDssSubscribeRequest === null || deereDssSubscribeRequest === undefined) {
            throw new Error('Required parameter deereDssSubscribeRequest was null or undefined when calling deereDssSubscribe.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cognito) required
        localVarHeaders = this.configuration.addCredentialToHeaders('cognito', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/oem-connection/deere/dss/subscribe`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DeereDssSubscribeResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: deereDssSubscribeRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deere per-org grant return path (D9).
     * Public route invoked by Deere Operations Center after the contractor completes a per-organisation grant. Trust is carried by the HMAC-signed &#x60;state&#x60; parameter (same pattern as the OAuth callback). Updates the relevant &#x60;oem_org_grants&#x60; row to &#x60;granted&#x60; and 302-redirects to the FE. 
     * @endpoint get /oem-connection/deere/grant-callback
     * @param oemOrgId The Deere organisation ID for which the grant was completed.
     * @param state HMAC-signed token carrying contractor identity.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deereGrantCallback(oemOrgId: string, state: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public deereGrantCallback(oemOrgId: string, state: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public deereGrantCallback(oemOrgId: string, state: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public deereGrantCallback(oemOrgId: string, state: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        if (oemOrgId === null || oemOrgId === undefined) {
            throw new Error('Required parameter oemOrgId was null or undefined when calling deereGrantCallback.');
        }
        if (state === null || state === undefined) {
            throw new Error('Required parameter state was null or undefined when calling deereGrantCallback.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'oem_org_id',
            <any>oemOrgId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'state',
            <any>state,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/oem-connection/deere/grant-callback`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Build a Deere Operations Center grant URL (D9).
     * Returns a Deere Operations Center URL the contractor is redirected to in order to complete the per-organisation grant. Returns 400 if the grant is already in &#x60;granted&#x60; state, 404 if the org is not associated with the calling contractor. 
     * @endpoint get /oem-connection/deere/grants/{oem_org_id}/grant-url
     * @param oemOrgId Deere organisation ID.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getDeereGrantUrl(oemOrgId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<GrantUrl>;
    public getDeereGrantUrl(oemOrgId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<GrantUrl>>;
    public getDeereGrantUrl(oemOrgId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<GrantUrl>>;
    public getDeereGrantUrl(oemOrgId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (oemOrgId === null || oemOrgId === undefined) {
            throw new Error('Required parameter oemOrgId was null or undefined when calling getDeereGrantUrl.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cognito) required
        localVarHeaders = this.configuration.addCredentialToHeaders('cognito', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/oem-connection/deere/grants/${this.configuration.encodeParam({name: "oemOrgId", value: oemOrgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/grant-url`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GrantUrl>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List Deere per-organisation grants (D9).
     * Returns one entry per Deere organisation associated with the contractor\&#39;s connection, including current grant status and timestamp. 
     * @endpoint get /oem-connection/deere/grants
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listDeereGrants(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<OrgGrant>>;
    public listDeereGrants(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<OrgGrant>>>;
    public listDeereGrants(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<OrgGrant>>>;
    public listDeereGrants(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (cognito) required
        localVarHeaders = this.configuration.addCredentialToHeaders('cognito', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/oem-connection/deere/grants`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<OrgGrant>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
